/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';


@Injectable({ providedIn: 'root' })
export class ApiFormingApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sendTiposProjectRequestAsync()` */
  static readonly SendTiposProjectRequestAsyncPath = '/api/tipos/project';

  /**
   * Processes a tipos request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendTiposProjectRequestAsync()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendTiposProjectRequestAsync$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, ApiFormingApiClient.SendTiposProjectRequestAsyncPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Processes a tipos request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendTiposProjectRequestAsync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendTiposProjectRequestAsync(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.sendTiposProjectRequestAsync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sendTiposFileRequestAsync()` */
  static readonly SendTiposFileRequestAsyncPath = '/{url}';

  /**
   * Processes a tipos request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendTiposFileRequestAsync()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendTiposFileRequestAsync$Response(
    params: {
      url: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, ApiFormingApiClient.SendTiposFileRequestAsyncPath, 'get');
    if (params) {
      rb.path('url', params.url, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Processes a tipos request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendTiposFileRequestAsync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendTiposFileRequestAsync(
    params: {
      url: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.sendTiposFileRequestAsync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
